/**
 * Curated list of voices clients can select for a voice agent.
 *
 * `value` is the Bland AI voice identifier persisted on the voice agent
 * (`VoiceAgent.voice`), `label` is what clients see in the dropdown.
 */
export interface VoiceOption {
  value: string
  label: string
  description?: string
}

// Kept in alphabetical order by label.
export const VOICE_OPTIONS: VoiceOption[] = [
  { value: '8b9f3974-d4e5-4704-9b71-96fb4dc73752', label: 'Allie' },
  { value: 'aa3e6150-6241-4228-b516-de9def9fd2e2', label: 'Alona' },
  { value: 'ffe9ba88-4d68-4b37-9172-e94e2caa32fa', label: 'Caylee' },
  { value: '60974bf8-151e-44e2-812e-4dc958aac5f3', label: 'Esteban' },
  { value: '47a153e0-4690-49a3-923b-b7a39dde8783', label: 'Josh' },
  { value: '29158307-9893-4149-8a75-bc9ce313d64e', label: 'Karen' },
  { value: 'c90fbac7-48f2-410f-82d2-6786ec4c7ad5', label: 'Kirsten' },
  { value: '7558e302-7aa3-4712-b10b-e485a20a785a', label: 'Sandra' },
  { value: 'f04af0e5-1a80-48a9-b02d-52f30d417cfa', label: 'Willow' },
  { value: 'yasmin', label: 'Yasmin' },
]

/**
 * Resolves a stored voice id to a friendly label, falling back to the raw id
 * so unknown/legacy values still render sensibly.
 */
export const getVoiceLabel = (value?: string | null): string => {
  if (!value) return ''
  return VOICE_OPTIONS.find((v) => v.value === value)?.label ?? value
}
